<template>
  <div v-if="isMountedRef" class="container pt-5">
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4 justify-items-center mt-5"
    >
      <div class="text-center md:pt-[100px]">
        <h1 class="font-bold mb-5">{{ title }}</h1>
        <p>{{ description }}</p>
      </div>
      <div>
        <img
          src="/images/404.png"
          class="mb-5 max-w-[540px] w-auto"
          alt="500"
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import * as Sentry from "@sentry/vue";
import type { NuxtError } from "#app";

const config = useRuntimeConfig();

const title = ref("");
const description = ref("");

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({}),
  },
});

const isMountedRef = ref(false);

onMounted(() => {
  // during an 500 error we can't use the useI18n so need to set these here "manually"
  if (config.public.locale === "hu-HU") {
    title.value = "Oldalkarbantartás";
    description.value =
      "Az oldal jelenleg karbantartás alatt áll! Kérjük, látogass vissza később!";
  } else if (config.public.locale === "ro-RO") {
    title.value = "Mentenanță site";
    description.value =
      "Pagina este momentan în mentenanță! Te rugăm să revii mai târziu!";
  } else if (config.public.locale === "sk-SK") {
    title.value = "Údržba stránky";
    description.value =
      "Stránka je momentálne pod údržbou. Prosím, skús neskôr.";
  }

  isMountedRef.value = true;

  Sentry.captureMessage("500 error page displayed", {
    level: "error",
    extra: {
      errorData: props.error,
      key: "ER-SPQ5",
    },
  });
});
</script>
